module.exports = __webpack_public_path__ + "static/media/sr.a96b947d.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/sr.svg
// module id = 984
// module chunks = 0